import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false, // 是否登录状态
    apiPermission: [], // 全局保存api权限
    includes: [], // keep-alive配置
    sidebarSwitch: true, // 侧边栏开关状态
    menuActive: '', // 菜单高亮
    breadList: [], // 面包屑
    fullPath: '' // 全局path
  },
  mutations,
  actions: {
  },
  modules: {
  }
})
